import type React from 'react';

import { alpha } from '@theme-ui/color';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconSentimentSatisfiedAlt, iconSentimentVeryDissatisfied } from '@change-corgi/design-system-legacy/icons';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

export const NotifiedOrRespondedStatus: React.FC<{
	daysSinceNotified: number | null | undefined;
	isNotified: boolean;
	hasResponded: boolean;
}> = ({ daysSinceNotified, isNotified, hasResponded }) => {
	if (!(isNotified || hasResponded)) return null;

	const getNotifiedSinceText = () => {
		if (daysSinceNotified === null || daysSinceNotified === undefined) return 'No response';
		if (daysSinceNotified === 0) return 'No response. Notified today';
		if (daysSinceNotified === 1) return 'No response. Notified 1 day ago';
		return `No response. Notified ${daysSinceNotified} days ago`;
	};

	const theme = hasResponded
		? {
				dataTestid: 'responded-status',
				statusText: 'Responded',
				backgroundColor: alpha('social-whatsapp', 0.2),
				icon: iconSentimentSatisfiedAlt,
			}
		: {
				dataTestid: 'notified-status',
				statusText: getNotifiedSinceText(),
				backgroundColor: '#FEE4E3',
				icon: iconSentimentVeryDissatisfied,
			};

	return (
		<Box mt={8} data-testid={theme.dataTestid}>
			<Flex
				sx={{
					display: 'inline-flex',
					background: theme.backgroundColor,
					borderRadius: 'standard',
					alignItems: 'center',
				}}
				px={8}
				py={2}
				mb={8}
			>
				<Icon icon={theme.icon} mr={8} />
				<Text size="small">{theme.statusText}</Text>
			</Flex>
		</Box>
	);
};
